import React, { useContext, useEffect, useState } from 'react'
import { Content } from './style'
import { ButtonCreate, LeftSide, OptionsButton, RightSide, SectionName, SubHeaderContainer } from '../../../components/subheader-style'
import TableCompanies from './CompaniesTable'
import ModalContext from '../../../contexts/ModalContext'
import FieldsManager, { FieldsManagerType } from '../../../components/FieldManager'
import { Settings2 } from 'lucide-react';
import { tableFields } from '../../../components/FieldManager/table-fields'
import WithoutSelectedFields from '../../SystemErrors/WithoutSelectedFields'

const CompaniesSubHeader:React.FC = () => {
  const { setModalActive, setModalSection } = useContext(ModalContext)
  
  const createCompany = () => {
    setModalActive(true)
    setModalSection('addCompany')
  }
  
  return(
    <SubHeaderContainer>
    <LeftSide>
      <SectionName>Empresas</SectionName>
    </LeftSide>
    <RightSide>
      <OptionsButton style={{visibility: 'hidden'}}><Settings2/></OptionsButton>
      <ButtonCreate onClick={() => createCompany()}>+ Cadastrar empresa</ButtonCreate>
    </RightSide>
  </SubHeaderContainer>
  )
}

const CompaniesContent = () => {
  const [ isdropdownOpen, setIsDropdownOpen ] = useState(false)
  const [ fields, setFields ] = useState(() => {
    const fromLocalStorage = localStorage.getItem('tableFields')
    if(fromLocalStorage) {
      const tableFieldsFromLocalStorage:FieldsManagerType[] = JSON.parse(fromLocalStorage)
      return tableFieldsFromLocalStorage.filter(field => field.tableSection === 'companies')[0]
    }
    return tableFields.filter(field => field.tableSection === 'companies')[0]
  })
  
  useEffect(() => {
    const fromLocalStorage = localStorage.getItem('tableFields')
    const tableFieldsJson = fromLocalStorage ? JSON.parse(fromLocalStorage) : tableFields
    const toLocalStorage = tableFieldsJson.map((table:FieldsManagerType) => {
      if(table.tableSection === 'companies') {
        return {...table, whichFieldsToShow: fields.whichFieldsToShow}
      }
      return table
    })

    localStorage.setItem('tableFields', JSON.stringify(toLocalStorage))
  }, [fields])
  
  return (
    <>
      <CompaniesSubHeader />
      <Content>
        {fields.whichFieldsToShow.filter((field:any) => field.checked).length === 0 ? 
          <WithoutSelectedFields dropdown={setIsDropdownOpen} />
        :
          <TableCompanies dropdownOpen={setIsDropdownOpen} whichFieldsToShow={fields}/>
        }
        {isdropdownOpen ? <FieldsManager dropdownOpen={setIsDropdownOpen} fields={fields} setFields={setFields}/> : null}
      </Content>
    </>
  )
}
export default CompaniesContent
